<template>
    <div class="goTop" @click="handleClick">
        <img class="goTopImage" src="@/assets/go-top.svg" alt="">
    </div>
</template>

<script>
export default {
    name: 'GoTop',
    methods: {
        handleClick() {
            window.scroll({ 
                top: 0,
                behavior: 'smooth' 
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.goTop {
    width: 40px;
    height: 40px;
    position: fixed;
    bottom: 1rem;
    right: 1rem;
    background: rgba(0, 0, 0, .3);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
    cursor: pointer;
    .goTopImage {
        width: 30px;
        height: 30px;
    }
}
</style>